import React from "react";
import { Box } from "@mui/material";
import OptionsMain from "./OptionsMain";
import Notification from "../components/customNotification/Notification";

const OptionsLayout = () => {
  return (
    <Box
      sx={{
        // minHeight: "calc(100vh - 63px)",
        height: "100%",
        position: "relative",
        // backgroundColor: "#f7fafc",
      }}
      className="options-layout-wrapper"
    >
      <Notification />
      <OptionsMain />
    </Box>
  );
};

export default OptionsLayout;
